import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: '首頁', path: '/' },
    { name: '關於朋睿', path: '/about' },
    { name: '服務方案', path: '/services' },
    { name: '資金方', path: '/funders' },
    { name: '需求方', path: '/borrowers' },
    { name: '媒合流程', path: '/process' },
    { name: '成功案例', path: '/cases' },
    { name: '常見問題', path: '/faq' },
    { name: '聯絡我們', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/91f3ee194275924d20a8df575f9e4888.png" 
              alt="鵬瑞資融" 
              className="h-40"
            />
          </a>

          <div className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="relative px-4 py-2 text-lg font-semibold text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap group"
              >
                <span className="relative">
                  {item.name}
                  <span 
                    className={`absolute left-0 right-0 bottom-0 h-0.5 bg-amber-500 transition-transform ${
                      location.pathname === item.path 
                        ? 'scale-x-100' 
                        : 'scale-x-0 group-hover:scale-x-100'
                    }`}
                    style={{ bottom: '-8px' }}
                  ></span>
                </span>
              </Link>
            ))}
          </div>

          <div className="hidden lg:flex items-center">
            <Link
              to="/contact"
              className="px-6 py-2.5 bg-amber-500 text-white text-sm font-semibold rounded-lg hover:bg-amber-600 transition-all whitespace-nowrap cursor-pointer"
            >
              免費諮詢
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-6 py-4 space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-4 py-3 text-base font-medium rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'text-gray-900 bg-amber-50 border-l-4 border-amber-500'
                    : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-6 py-3 bg-amber-500 text-white text-base font-semibold rounded-lg hover:bg-amber-600 transition-all text-center mt-4 cursor-pointer whitespace-nowrap"
            >
              免費諮詢
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
